module.exports = __webpack_public_path__ + "img/guanbi.137c19cc.svg";